import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${({ theme }) => theme.space[6]};
  text-align: center;
`;

export const ErrorCode = styled.h1`
  font-size: 72px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.gray200};
  margin: 0;
  line-height: 1;
`;

export const ErrorMessage = styled.p`
  font-size: ${({ theme }) => theme.fonts.md};
  color: ${({ theme }) => theme.colors.gray500};
  margin: ${({ theme }) => theme.space[3]} 0 ${({ theme }) => theme.space[7]} 0;
  max-width: 320px;
`;

export const HomeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[2]};
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => `${theme.space[3]} ${theme.space[5]}`};
  font-size: ${({ theme }) => theme.fonts.base};
  font-weight: 500;
  cursor: pointer;
  transition: background-color ${({ theme }) => theme.transitions.fast};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primaryDark};
  }
`;
